module.exports = __webpack_public_path__ + "static/media/Deans-Award-Winners_2022.62a343bd.jpg";